var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    [
      _c(
        "b-row",
        {
          ref: "dropzone",
          staticClass: "dropzone needsclick dz-clickable",
          on: {
            click: function ($event) {
              return _vm.$refs.fileInput.click()
            },
          },
        },
        [
          _c("div", { staticClass: "dz-message needsclick" }, [
            _c("p", { staticClass: "font-xsm" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("file.messages.dropzone.0")) +
                  "\n        "
              ),
              _c("span", { staticClass: "text-primary" }, [
                _vm._v(_vm._s(_vm.$t("file.messages.dropzone.1"))),
              ]),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("file.messages.dropzone.2")) +
                  "\n      "
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.showFilesQuantity && _vm.files.length > 0
        ? _c(
            "b-row",
            {
              staticClass:
                "text-primary font-sm bold d-flex justify-content-end",
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$tc(
                      "file.messages.quantityOfFilesToUpload",
                      _vm.files.length,
                      {
                        quantity: _vm.files.length,
                      }
                    )
                  ) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showFilesNames && _vm.files.length > 0
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                _vm._l(_vm.filesNames, function (fileName) {
                  return _c(
                    "b-row",
                    {
                      key: fileName,
                      staticClass: "font-sm d-flex justify-content-end",
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "mb-2 word-break-all text-right" },
                        [
                          _vm._v(
                            "\n          " + _vm._s(fileName) + "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c(
            "b-button",
            {
              staticClass: "bold m-3",
              attrs: { size: "sm", variant: "primary" },
              on: {
                click: function ($event) {
                  return _vm.$refs.fileInput.click()
                },
              },
            },
            [
              _c("icon", { attrs: { name: "upload" } }),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("file.actions.uploadADocument")) +
                  "\n    "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.clearButton
            ? _c(
                "b-button",
                {
                  staticClass: "bold m-3",
                  attrs: { size: "sm", variant: "white" },
                  on: {
                    click: function ($event) {
                      return _vm.removeAllFiles(true)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("file.actions.clearDocuments")) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            ref: "fileInput",
            staticStyle: { display: "none" },
            attrs: {
              id: "file-input",
              type: "file",
              accept:
                "application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,image/png,image/tiff,image/jpeg",
              multiple: "",
            },
            on: { change: _vm.handleFilesSelected },
          }),
          _vm._v(" "),
          _c("label", { staticClass: "d-none", attrs: { for: "file-input" } }, [
            _vm._v(_vm._s(_vm.$t("global.words.document"))),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }